import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Container, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Information from '../../../PracticesPage/Components/Information';
import ConfirmPopup from '../../../../Components/Popup/ConfirmPopup';

const useStyles = () => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '8%',
    alignItems: 'center',
    maxHeight: '80px',

    pt: '12px',
    pb: '12px',
  },
  icnWrap: {
    display: 'flex',
    alignItems: 'center',
  },
});

const LeadOriginsListItem = function LeadOriginsListItem({
  data,
  onClick,
  onDelete,
}) {
  const intl = useIntl();
  const classes = useStyles();

  const [confirmDelete, setIsDelete] = useState(false);

  const openConfirmDeletion = (event) => {
    event.stopPropagation();
    setIsDelete(event.currentTarget);
  };
  return (
    <>
      <Container
        id="leadOrigins-entry"
        sx={classes.root}
        style={{ maxWidth: 'unset' }}
      >
        <Information caption={intl.messages.NAME} value={data?.leadOrigin} />
        <div
          style={{
            minWidth: '64px',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Tooltip title={intl.messages.EDIT_LEAD_ORIGIN} placement="bottom">
            <IconButton
              id="leadOrigin-edit-iconButton"
              onClick={() => onClick(data)}
            >
              <EditIcon fontSize="inherit" />
            </IconButton>
          </Tooltip>
          <Tooltip title={intl.messages.DELETE} placement="bottom">
            <IconButton
              key={data.id}
              data-testid="leadOrigin-delete-iconButton"
              onClick={openConfirmDeletion}
            >
              <DeleteIcon fontSize="inherit" />
            </IconButton>
          </Tooltip>
        </div>
      </Container>
      <ConfirmPopup
        confirmText={intl.messages.CONFIRM_LEAD_ORIGIN}
        open={Boolean(confirmDelete)}
        anchorEl={confirmDelete}
        close={() => setIsDelete(null)}
        handleConfirm={() => onDelete(data.id)}
      />
    </>
  );
};

LeadOriginsListItem.propTypes = {
  data: PropTypes.object,
  onClick: PropTypes.func,
  onDelete: PropTypes.func,
};
export default LeadOriginsListItem;
